module.exports = __webpack_public_path__ + "img/product_banner_energy.03e8a910.png";